import { mapStore } from 'stores/MapStore';

const handleWinterWindContourLegend = () => {
  const legendLabels = document.getElementsByClassName('esriLegendLayerLabel');

  for (let i = 0; i < legendLabels.length; i++) {
    const legendLabel = legendLabels[i];

    const legendTitleElement = legendLabel.querySelector('td');
    if (legendTitleElement) {
      const legendTitle = legendTitleElement.innerHTML;

      if (legendTitle === 'Winter Wind Contour') {
        const legendElementTable = legendLabel.nextElementSibling;
        const legendTr = legendElementTable.querySelector('tr');

        if (legendTr) {
          const tds = legendTr.children;

          if (tds.length === 2) {
            legendTr.removeChild(tds[1]);

            const legendImg = tds[0].querySelector('img');
            if (legendImg) {
              const td = tds[0];
              td.removeChild(legendImg);
              td.classList.add('winter-wind-contour-legend-container');

              const span = document.createElement('span');
              span.classList.add('winter-wind-contour-legend');

              td.appendChild(span);
              return;
            }
          }
        }
      }
    }
  }
};

export const startLegendObserver = (element) => {
  const config = { attributes: false, childList: true, subtree: false };

  const callback = () => {
    const { has722WinterWindContourLegend } = mapStore.getState();

    if (has722WinterWindContourLegend) {
      handleWinterWindContourLegend();
    }
  };

  var observer = new MutationObserver(callback);

  observer.observe(element, config);
};
